import { useCallback, useState } from "react";

export default function useOpenState() {
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const onOpenChange = useCallback((eventOrValue) => {
    if (typeof eventOrValue === "boolean") {
      setOpen(eventOrValue);
      if (!eventOrValue) setAnchorEl(null);
      return;
    }

    setAnchorEl(eventOrValue?.currentTarget);
    setOpen(true);
  }, []);

  return {
    open,
    anchorEl,
    onOpenChange,
  };
}
